import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from "@mui/icons-material/Upload";
import AreasOfWorkSection from "../sections/AreasOfWorkSection";
import useApi from "../../api/useApi";
import { toast } from "react-toastify";
import { useLocation } from "react-router";


export default function AddCategoryForm({ onAddcategory }) {

  const CATEGORY_FORM_STORAGE_KEY = 'categoryFormState';

  const [open, setOpen] = useState(false);
  const location = useLocation()
  const [uploadingImage,  setUploadingImage] = useState(false)

  const [category, setCategory] = useState({
    name: "",
    category_alias: "",
    description: "",
    link:"",
    image_introduction:"",
    released:false
  });

  const [tabPreviewCreate, setTabPreviewCreate] = useState(0); // 0 = New, 1 = Preview
  const [tabIndex, setTabIndex] = useState(0); // 0 = Link, 1 = Upload
  const fileInputRef = useRef(null);

  // 

  // create of work categories
  
    const { request: createCategory, data:createCategoryData, error:createCategoryError} = useApi(onAddcategory);
              
        useEffect(()=>{
          if (createCategoryData?.status===201) {
            toast.success(`${JSON.stringify(createCategoryData?.data,null,2)}`,{position: "top-center"});
            setOpen(false);
            window.localStorage.removeItem(CATEGORY_FORM_STORAGE_KEY);
            setCategory({
              name: "",
              category_alias: "",
              description: "",
              link:"",
              image_introduction:"",
              released:false
            })
            // setAreas(createCategoryData?.data);
          }
        // eslint-disable-next-line
        },[createCategoryData])
    
        // useEffect(()=>{
        //     if(location?.state?.refresh==="category"){
        //       createCategory();
        //     }
        //   // eslint-disable-next-line
        // },[location?.state])
      
        useEffect(()=>{
            if(createCategoryError){
                toast.error(`${JSON.stringify(createCategoryError?.response?.data,null,2)}`,{position: "top-center"});
          }
        },[createCategoryError])
    // End create area of work categories
  // 

  const generateAlias= (e) => {
    const name = category?.name.trim();
    const alias = name
      .toLowerCase()         // make all lowercase
      .replace(/\s+/g, '-'); // replace spaces with hyphens
    // document.getElementById('categoryAlias').value = alias;
    return alias
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategory((prev) => ({ ...prev, [name]: value }));
    

    window.localStorage.setItem(CATEGORY_FORM_STORAGE_KEY, JSON.stringify(category));
  };


  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Convert to local preview URL
      const previewUrl = URL.createObjectURL(file);
      setCategory((prev) => ({ ...prev, value: previewUrl }));
      
      const formData = new FormData();
      formData.append("image", file);
      setUploadingImage(true)
      try{
        // const res = await fetch("https://178.128.35.136/cms/ftp-files/", {
          const res = await fetch("/cms/ftp-files/", {
          method: "POST",
          body: formData, // don't add headers here
        });
      // console.log(res)
      if(res?.status===201){
        let result = await res.json()
        // console.log("Upload urls: ",result)
        setCategory((prevData)=>({
          ...prevData,
          image_introduction: result?.path,
        }));
        setUploadingImage(false)
      // setMaterialUrl(event,event.target.value)
        // setUploadUrls(prev=>res?.data)
        // setConstFileUpload(false)
      }else{
        console.log(res)
      }
      }catch(error){
        console.log(error)
      }
  
      }
  }



  const handleSubmit = () => {
    if (!category.name) return alert("Please provide a name value.");
    createCategory(category);
    // setCategory({ type: "text", heading: "", value: "" });
    
  };

  useEffect(() => {
    const saved = window.localStorage.getItem(CATEGORY_FORM_STORAGE_KEY);
    if (saved) {
      try {
        const obj = JSON.parse(saved);
        // if (obj.name) setName(obj.name);
        // if (obj.alias) setAlias(obj.alias);
        setCategory(obj);
      } catch (err) {
        console.error('Could not parse saved category form state', err);
      }
    }
  }, []);

  useEffect(() => {
    const saved = window.localStorage.getItem(CATEGORY_FORM_STORAGE_KEY);
    if (category?.name?.length>0) {
      setCategory((prev) => ({ ...prev, category_alias: generateAlias() }));
      setCategory((prev) => ({ ...prev, link: `/what-we-do/${category?.category_alias}` }));
    window.localStorage.setItem(CATEGORY_FORM_STORAGE_KEY, JSON.stringify(category));
    }
  }, [category?.name,category?.category_alias]);



  // window.localStorage.removeItem(CATEGORY_FORM_STORAGE_KEY);

  return (<>
      {/* Add category Button */}
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => setOpen(true)}
        sx={{ mb: 2 }}
      >
        Add Category
      </Button>

      {/* Popup Form */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add Working Area Category</DialogTitle>
        <DialogContent>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            <Typography
            sx={{
                mb:5,
            }}
            >Add a new activity category (what we do category) that represents the areas your organization works in — such as Health, Education, Environment, or Media. These categories help group and organize your organization’s projects and initiatives.
            </Typography>

            <>
            <Tabs
              value={tabPreviewCreate}
              onChange={(e, newValue) => setTabPreviewCreate(newValue)}
              centered
              sx={{ mb: 1 }}
            >
              <Tab label="New Category" />
              <Tab label="Preview" />
            </Tabs>
            {tabPreviewCreate === 0 ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            {/* Category Name */}
            <TextField
              name="name"
              label="Category Name"
              value={category.name}
              onChange={handleChange}
              fullWidth
            >
            </TextField>

            <TextField
              name="name"
              label="Category Alias"
              placeholder="Generated alias"
              value={category.category_alias}

              onChange={handleChange}
              fullWidth
            ></TextField>
            

            {/* Category Description */}
            <TextField
              name="description"
              label="Description (optional)"
              value={category.description}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={4}
            />

            {/* Category Image Introduction */}
            <>
              <Tabs
                value={tabIndex}
                onChange={(e, newValue) => setTabIndex(newValue)}
                centered
                sx={{ mb: 1 }}
              >
                <Tab label="Category Image Introduction Link" />
                <Tab label="Upload Category Image Introduction" />
              </Tabs>

              {tabIndex === 0 ? (
                <TextField
                  name="image_introduction"
                  label="image Link"
                  value={category.image_introduction}
                  onChange={handleChange}
                  fullWidth
                />
              ) : (
                <Box
                  sx={{
                    border: "2px dashed #ccc",
                    borderRadius: 2,
                    p: 3,
                    textAlign: "center",
                  }}
                >
                  {category?.image_introduction ? (
                    category?.image_introduction?.length >= 0 ? (
                      <img
                        src={category.image_introduction}
                        alt="preview"
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                          marginBottom: "8px",
                        }}
                      />
                    ) : (
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        File selected: {category?.image_introduction.split("/").pop()}
                      </Typography>
                    )
                  ) : (
                    <UploadIcon sx={{ fontSize: 50, color: "#aaa", mb: 1 }} />
                  )}

                  <Button
                    variant="outlined"
                    onClick={() => fileInputRef.current.click()}
                    loading ={uploadingImage}
                  >
                    {category.image_introduction ? "Click Change File" : "Click to Upload File"}
                  </Button>
                  <input
                    type="file"
                    accept={"image/*"}
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                </Box>
              )}
            </>
            </Box>
            ):
            (
              <AreasOfWorkSection singleView={[category,]} />
            )
            } 
        </>
        </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
